<template>
  <div id="newsinfo-m" v-loading.fullscreen.lock="newLoading">
    <div class="title" v-lazy-bg>
      <div class="title-top">
        新闻中心
      </div>
      <div class="title-description">
        了解有关晓果智学的所有最新公司动态
      </div>
    </div>
    <div class="newsinfo-inner">
      <!-- 内容 -->

      <div class="main">
        <div class="firstline">
          <div class="back">
            <img v-lazy="fontAssetsURL(`mobile/newsinfo/左_深色.png`)" @click="back" alt="" />
          </div>
          <div class="main-title">
            {{ val.title }}
          </div>
        </div>

        <div class="main-2">
          <div class="main-2-1">
            <img v-lazy="fontAssetsURL(`news/图层 905.png`)" class="img1" alt="" />
            {{ val.pushTime }}
          </div>
          <div class="main-2-2">
            <img v-lazy="fontAssetsURL(`news/图层 906.png`)" class="img2" alt="" />
            {{ val.count }}
          </div>
        </div>
        <!-- class="main-content" -->
        <div class="ql-snow">
          <div class="ql-editor main-content" v-html="infoHtml"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gethomePageNewsDetail } from "../server/api";
export default {
  data() {
    return {
      newLoading:false,
      val: {}, //本页对象
      infoHtml: "", //获取的内容 文章
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getIframe();
    });
  },
  methods: {
    gethomePageNewsFun(){
      this.newLoading = true
      gethomePageNewsDetail({id:this.$route.query.id}).then(res=>{
        this.infoHtml = res.data[0].content
        this.newLoading = false;
      })
    },
    // 返回
    back() {
      this.$router.push("/news");
    },
    getIframe() {
      console.log(document.querySelector(".ql-video> video"));
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.val = vm.$route.query;
      vm.gethomePageNewsFun()
    });
  },
};
</script>

<style scoped>
@import "../style_mobile/newsinfo.css";
</style>
